import * as _ from "lodash";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import npdiAccountSetupEvents from "./events/NpdiAccountSetupEvents";

var npdiAccountSetupController = function (
    $q,
    $rootScope,
    $scope,
    $state,
    $timeout,
    $translate,
    PersonalContactInfoCustomValidator,
    PersonalContactInfoUpdateUtil,
    eventBus,
    npdiFactory,
    redirectService
) {
    const logger = ExternalLogger.getInstance("NpdiAccountSetupController");
    var vm = this;
    var deferred = $q.defer();

    $scope.submitted = false;
    $scope.pecbypassregEnabled = false;

    npdiFactory.isPECKTMGEnabled.query()
        .$promise.then(function (data) {
            if (data !== null) {
                $scope.pecbypassregEnabled = _.get(data, 'WNPECN');
            }
        }, function (error) {
            logger.error("ERROR ndpiFactory.isPECKTMGEndabled():", error);
        });

    $scope.personalInfo = {
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: '',
        gender: '',
        ssn: '',
        maritalStatus: ''
    };

    $scope.employmentInfo = {
        currentAnnualIncome: '',
        dateOfHire: ''
    };

    $scope.mailingAddress = {
        addressLine1: '',
        addressLine2: '',
        city: '',
        zipcode: ''
    };

    $scope.stateOptions = {
        code: '',
        description: ''
    };
    $scope.selectedStateValue = {
        code: '',
        description: ''
    };

    $scope.zipcode = '';

    $scope.countryOptions = {
        code: '',
        description: ''
    };
    $scope.selectedCountryValue = {
        code: '',
        description: ''
    };

    $scope.maritalStatusOptions = {
        code: '',
        description: ''
    };

    $scope.genderListOptions = {};

    $scope.selectedGenderValue = '';

    $scope.selectedMaritalStatusValue = {
        code: '',
        description: ''
    };

    $scope.userInfo = {
        username: '',
        password: '',
        confirmPassword: ''
    };

    $scope.cleaveoptions = {
        ssn: {
            blocks: [3, 2, 4],
            uppercase: true,
            delimiters: ['-']
        }
    };

    $scope.validationStatus = "";
    $scope.validationStatusParams = "";
    $scope.errors = [];

    /**
     * focus manager
     * indexed by fieldName
     * @type {{}}
     */
    $scope.focusMgr = {};

    $scope.forceValidations = function (inputs) {
        inputs.forEach(function (input) {
            $scope.accountSetupForm[input].$touched = true;
            $scope.accountSetupForm[input].$dirty = true;
        });
    };

    /**
     * focus manager
     * indexed by fieldName
     * @type {{}}
     */
    $scope.focusMgr = {};

    $scope.getValidField = function (fieldName) {
        var field = $scope.accountSetupForm[fieldName].$valid;

        return field;
    };

    $scope.isDirty = function (fieldName) {

        var dirty = $scope.accountSetupForm[fieldName].$dirty;

        return dirty;
    };


    $scope.displayFieldMessages = function (fieldName) {
        var field = $scope.accountSetupForm[fieldName];
        if (!field) {
            return true;
        }
        var conditions = (field.$invalid && field.$dirty) || (field.$invalid && $scope.accountSetupForm.$submitted) || field.$touched || !field.$pristine;
        return conditions;
    };

    /*
    $scope.fieldOnBlur = function (fieldName) {
        var field = $scope.accountSetupForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = '';

        //console.log(fieldName + '|touched:' + field.$touched + '|invalid:' + field.$invalid + '|focused:' + fieldFocused);
        if (field.$touched && field.$invalid && !fieldFocused ) {
            status = 'has-error';
        }
        return status;
    };
    */

    $scope.getFormGroupClass = function (fieldName) {
        var field = $scope.accountSetupForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = '';

        if (field.$invalid && field.$dirty && !fieldFocused) {
            status = 'has-error';
        }

        if (field.$valid && field.$dirty) {
            status = 'has-success';
        }
        return status;
    };

    $scope.isTouched = function (fieldName) {
        return $scope.accountSetupForm[fieldName].$dirty;
    };

    $scope.getFieldError = function (fieldName) {
        return $scope.accountSetupForm[fieldName].$error;
    };

    /**
    * determine the validation error (style) class.
    * different class if one error vs multiples.
    */
    $scope.getValidationErrorClass = function (fieldName) {
        var styleName = 'rule-validations';

        if (_.isUndefined($scope.accountSetupForm) || !fieldName || _.isUndefined($scope.accountSetupForm[fieldName])) {
            return style;
        }
        var errs = $scope.accountSetupForm[fieldName].$error;
        var errorKeys = _.keys(errs);

        var errorCnt = _.size(errorKeys);

        //if >1 errors, the style class should be bulleted.
        if (errorCnt > 1) {
            styleName = 'form-validation-rule';
        }

        return styleName;
    };

    $scope.removeInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = false;
    };

    $scope.setInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = true;
        $scope.accountSetupForm[event.target.name].$setTouched(true);
        $scope.accountSetupForm[event.target.name].$setDirty(true);
    };


    $scope.loadContactInfo = function () {
        eventBus.dispatch(npdiAccountSetupEvents.CONTINUE, this);

        ContactDetailsFactory.retrieveContactDetails.query({},
            function (data, headers) {
                console.log("   Contact info retrived" + data);
                if (data !== null) {


                    $scope.contactDetails = data;
                    $scope.intlNumber = data.intlNumber;
                    $scope.personalEmailAddress = data.personalEmailAddress;
                    $scope.mobilePhoneNumber = data.domesticMobile;
                    if (data.intlNumber != null) {
                        $scope.intlNumberIdI = $scope.intlNumber;
                        $scope.intlNumberIdD = $scope.intlNumber;
                    }

                    if (data.domesticMobile !== null) {
                        $scope.mobilePhoneNumber = data.domesticMobile;
                        $scope.phoneNumberIdD = data.domesticMobile;
                        $scope.phoneNumberIdI = data.domesticMobile;
                        $scope.selectedCntryPhCodeD = "+" + data.domesticCntryCode.substring(2)

                    }

                    if (data.intCntryCode != null && data.intCntryCode != '')
                        $scope.selectedCntryPhCodeI = "+" + data.intCntryCode.substring(2);

                    /* $scope.contactInfo.phoneNumber = data.data.phoneNumber;
                     $scope.contactInfo.phoneNumberDisplay = "(" + data.data.phoneNumber.substring(0, 3) + ") " +
                         data.data.phoneNumber.substring(3, 6) +
                         "-" + data.data.phoneNumber.substring(6);*/

                }

            }, function (error) {
                if (error.data.status == 'FAIL') {
                    $scope.saveStatus = error.data.error.code;
                    $scope.saveStatusParams = error.data.error.errors[0];
                }
                logger.error("ERROR - ContactDetailsFactory.retrieveContactDetails: ", error);
            });

    };


    $scope.populateSelectedCntryPhoneCode = function (fieldName) {
        var temp = $("#" + fieldName).val();
        if (fieldName === 'ContactCountryNameI') {
            $scope.selectedCntryPhCodeI = "+" + temp.substring(2)
        }
        else if (fieldName === 'ContactCountryNameD') {
            $scope.selectedCntryPhCodeD = "+" + temp.substring(2)
        }
    };

    $scope.retrieveContactDetailsDropdown = function () {
        npdiFactory.retrieveContactDetailsDropdown.query({},
            function (data, headers) {
                logger.debug("npdiFactory.retrieveContactDetailsDropdown - Contact info retrived: ", data);
                if (data !== null) {
                    $scope.contactDetails = data;
                    $scope.intlNumber = data.intlNumber;
                    $scope.personalEmailAddress = data.personalEmailAddress;
                    $scope.mobilePhoneNumber = data.domesticMobile;
                    if (data.intlNumber != null) {
                        $scope.intlNumberIdI = $scope.intlNumber;
                        $scope.intlNumberIdD = $scope.intlNumber;
                    }

                    if (data.domesticMobile !== null) {
                        $scope.mobilePhoneNumber = data.domesticMobile;
                        $scope.phoneNumberIdD = data.domesticMobile;
                        $scope.phoneNumberIdI = data.domesticMobile;
                        $scope.selectedCntryPhCodeD = "+" + data.domesticCntryCode.substring(2)

                    }

                    if (data.intCntryCode != null && data.intCntryCode != '') {
                        $scope.selectedCntryPhCodeI = "+" + data.intCntryCode.substring(2);
                    }
                }
            }, function (error) {
                if (error.data.status == 'FAIL') {
                    $scope.saveStatus = error.data.error.code;
                    $scope.saveStatusParams = error.data.error.errors[0];
                }
            });
    };



    $scope.setUpAccount = function () {

        // Everything is good, we can continue with registration
        $rootScope.flowName = 'npdiAccountSetupFlow';
        var contactPostData = PersonalContactInfoUpdateUtil.getUpdateContactInfoJson($rootScope.flowName, $scope.contactDetails.personalEmailAddress, $scope.contactDetails.domesticCntryCode, $scope.contactDetails.intCntryCode);
        var validaityOfForm = PersonalContactInfoCustomValidator.validatePersonalInfo($scope.contactDetails.personalEmailAddress, $scope.contactDetails.domesticCntryCode, $scope.contactDetails.intCntryCode);
        if (!validaityOfForm.validForm) {
            $scope.accountSetupForm.$valid = false;
            $scope.phoneNum_error = validaityOfForm.errorCode;
        }

        var registePostData = {
            "username": $scope.userInfo.username,
            "password": $scope.userInfo.password,
            "flowName": $rootScope.flowName,
            "contactInfo": contactPostData
        };

        if ($scope.accountSetupForm.$valid) {
            $scope.showSpinner = true;
            setTimeout(function () {
                npdiFactory.addNPDIppt.query(registePostData).$promise.then(
                    onRegisterUserSuccess, onRegisterUserFailure
                );
            }, 10);
        } else {
            // Some input is not valid, so we need to prompt the participant to fix the issue
            // Manually set the $dirty flag for each input in the form to trigger validation
            var inputs = [
                'email',
                'phoneNumber',
                'username',
                'password',
                'confirmPassword'
            ];
            $scope.forceValidations(inputs);
        }
    };

    function onRegisterUserSuccess(registeResponse) {
        if (registeResponse !== null && registeResponse.status === "successful") {
            redirectService.redirect(registeResponse, 'ALL');
        } else {
            $scope.saveStatus = registeResponse.status;
        }
        $scope.showSpinner = false;
        deferred.resolve();
    }

    function onRegisterUserFailure(error) {

        if (error.headers('exception') !== null || error.headers('exceptionMessage') !== null) {
            $scope.saveStatus = error.data.error.code;
            $scope.saveStatusParams = error.data.error.errors[0];
        } else {

            if (error.data.data.userName !== null) {
                $scope.usernameError = error.data.data.userName;
            }
            if (error.data.data.password !== null) {
                $scope.passwordError = error.data.data.password;
            }
            //$scope.saveStatus = "Could not save contact Information";
        }
        $scope.showSpinner = false;
        deferred.reject(err);
    }

    $scope.usernameChange = function () {

        eventBus.dispatch(npdiAccountSetupEvents.USRNM_CHANGE, this, {
            username: $scope.userInfo.username
        });
    };

    $scope.passwordChange = function () {
        eventBus.dispatch(npdiAccountSetupEvents.PASS_CHANGE, this);
    };

    $scope.confirmPassChange = function () {
        eventBus.dispatch(npdiAccountSetupEvents.CONFIRM_PASS_CHANGE, this);
    };

    $scope.registerClick = function () {
        eventBus.dispatch(npdiAccountSetupEvents.REGISTER, this);
    };

    $scope.continueClick = function () {
        eventBus.dispatch(npdiAccountSetupEvents.CONTINUE, this);
    };

    $translate(["setUpAccountTitleNpdi", "completeRegistrationInfo", "contactInformationTitle", "usernamePasswordTitle"]).then(function (translations) {
        angular.extend($scope, {
            translatedData: {
                setUpAccountTitle: translations.setUpAccountTitleNpdi,
                completeRegistrationInfo: translations.completeRegistrationInfo,
                contactInformationTitle: translations.contactInformationTitle,
                usernamePasswordTitle: translations.usernamePasswordTitle
            }
        });
    });
};

npdiAccountSetupController.$inject = [
    '$q',
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$translate',
    'PersonalContactInfoCustomValidator',
    'PersonalContactInfoUpdateUtil',
    'eventBus',
    'npdiFactory',
    'redirectService'
];
export default npdiAccountSetupController;